import React from 'react'

const AboutUs = () => {
  return (
    <div>aboutUs</div>
  )
}

export default AboutUs